import { Component, inject, Input, OnChanges, OnInit, SimpleChanges } from "@angular/core";
import { GraphqlService } from "../../../../../services/graphql.service";
import { responseField } from "../../../../../store/base.graphql";
import gql from "graphql-tag";

export interface HeatmapZone {
  zone_id: number;
  zone_name: string;
  avg_temperature: number;
  avg_humidity: number;
  stability_score: number;
}

export interface HeatmapWarehouse {
  warehouse: string;
  zones: HeatmapZone[];
}

export const GET_ALL_WAREHOUSES_HEATMAP = gql`
query GetAllWarehousesHeatmap($filtering: ReportsFilteringInputObject) {
  getAllWarehousesHeatmap(filtering: $filtering) {
    response {
      ${responseField}
    }
    data {
      dashboardData
    }
  }
}`;

@Component({
  selector: "app-warehouse-heatmap",
  templateUrl: "./warehouse-heatmap.component.html",
  styleUrls: ["./warehouse-heatmap.component.scss"],
})
export class WarehouseHeatmapComponent implements OnInit, OnChanges {
  private apollo: GraphqlService = inject(GraphqlService);

  @Input() warehouseId: string;

  heatmapData: HeatmapWarehouse[] = [];
  heatmapLoading: boolean = false;
  activeHeatmapSlug: 'temperature' | 'humidity' = 'temperature';
  heatmapTabs: { name: string; slug: 'temperature' | 'humidity' }[] = [
    { name: 'Temperature', slug: 'temperature' },
    { name: 'Humidity', slug: 'humidity' },
  ];

  ngOnInit() {
    this.fetchHeatmapData();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['warehouseId'] && !changes['warehouseId'].firstChange) {
      this.fetchHeatmapData();
    }
  }

  async fetchHeatmapData() {
    this.heatmapLoading = true;
    try {
      const response: any = await this.apollo.query({
        query: GET_ALL_WAREHOUSES_HEATMAP,
        variables: {
          filtering: {
            warehouse: this.warehouseId,
          },
        },
      });

      const result = response?.data?.getAllWarehousesHeatmap;
      if (result?.response?.status) {
        const raw = result?.data?.dashboardData;
        this.heatmapData = typeof raw === 'string' ? JSON.parse(raw) : raw;
      }
    } catch (e) {
      console.error("Error fetching heatmap data:", e);
    } finally {
      this.heatmapLoading = false;
    }
  }

  getTempCellColor(temp: number): string {
    if (temp >= 35) return '#d94a4a';
    if (temp >= 30) return '#e8725a';
    if (temp >= 25) return '#e8993a';
    if (temp >= 20) return '#e8c84a';
    if (temp >= 15) return '#8cbf4a';
    return '#52b868';
  }

  getHumCellColor(hum: number): string {
    if (hum >= 80) return '#2b52a4';
    if (hum >= 65) return '#3a6fc4';
    if (hum >= 50) return '#4a8ad6';
    if (hum >= 35) return '#6ba8e0';
    return '#96c6ea';
  }
}
